import { render, staticRenderFns } from "./CompanySetupAI.vue?vue&type=template&id=b2da714e&scoped=true"
import script from "./CompanySetupAI.vue?vue&type=script&lang=js"
export * from "./CompanySetupAI.vue?vue&type=script&lang=js"
import style0 from "./CompanySetupAI.vue?vue&type=style&index=0&id=b2da714e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2da714e",
  null
  
)

export default component.exports